<template>
  <transition name="fade">
    <div class="share" v-if="visible">
      <div class="share-shadow" @click="hideSharePopup"></div>
      <div class="share-main">
        <div class="share-group">
          <div class="share-btn" @click="shareFacebook">
            <a href="javascript:;" class="facebook"></a>
            <p class="share-btn-text">facebook</p>
          </div>
          <div class="share-btn" @click="shareTwitter">
            <a href="javascript:;" class="twitter"></a>
            <p class="share-btn-text">twitter</p>
          </div>
          <div class="share-btn" @click="shareLine">
            <a href="javascript:;" class="line"></a>
            <p class="share-btn-text">line</p>
          </div>
          <div class="share-btn" @click="shareVk">
            <a href="javascript:;" class="vk"></a>
            <p class="share-btn-text">vk</p>
          </div>
          <div class="share-btn" @click="shareNaver">
            <a href="javascript:;" class="naver"></a>
            <p class="share-btn-text">naver</p>
          </div>
          <div v-if="shareSystemInst.isSupport()" class="share-btn" @click="shareSystem">
            <a href="javascript:;" class="more"></a>
            <p class="share-btn-text">More</p>
          </div>
        </div>
        <a href="javascript:;" class="main-close" @click="hideSharePopup"></a>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
export default {
  name: 'sharePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shareSystemInst: null,
      shareFacebookInst: null,
      shareTwitterInst: null,
      shareLineInst: null,
      shareVkInst: null,
      shareNaverInst: null,
      shareSystemInst: null,

      shareList: [],
      curHost: '',
      shareUrl: '',
      beforeLang: ''
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig'])
  },
  methods: {
    sharePoint(eventName, eventType, eventReason, eventValue) {
      window.webstorev1DataLayer.push({
        eventName: eventName || '',
        eventType: eventType || '',
        eventReason: eventReason,
        eventValue: eventValue || ''
      });
    },
    hideSharePopup() {
      this.$emit('closeSharePopup');
    },
    shareSystem() {
      this.sharePoint('share_channel', '更多（系统分享)', 'sharePopup');
      this.shareSystemInst.share();
    },
    // Facebook分享
    shareFacebook() {
      this.sharePoint('share_channel', 'Facebook', 'sharePopup');
      this.shareFacebookInst.share();
    },
    // Twitter分享
    shareTwitter() {
      this.sharePoint('share_channel', 'Twitter', 'sharePopup');
      this.shareTwitterInst.share();
    },
    // Line分享
    shareLine() {
      this.sharePoint('share_channel', 'Line', 'sharePopup');
      this.shareLineInst.share();
    },
    // vk分享
    shareVk() {
      this.sharePoint('share_channel', 'VK', 'sharePopup');
      this.shareVkInst.share();
    },
    // Naver分享
    shareNaver() {
      this.sharePoint('share_channel', 'Naver', 'sharePopup');
      this.shareNaverInst.share();
    },
    //分享初始化，构建实例
    initShare() {
      const mainHost = globalConfig.getMainHost();
      const Host = mainHost.split('.')[0];
      this.curHost = Host;
      this.shareUrl = `https://pay.${Host}.com/platform/officialStore.html?gameId=${this.gameId}`;

      this.shareFacebookInst = new ShareFacebook(
        this.gameInfoConfig.shareFacebookAppId
      );
      this.shareSystemInst = new ShareSystem();
      this.shareTwitterInst = new ShareTwitter();
      this.shareLineInst = new ShareLine();
      this.shareNaverInst = new ShareNaver();
      this.shareVkInst = new ShareVk();

      this.initShareSetting();

      // 设置title
      this.shareFacebookInst.setTitle(this.letter.firstPayOff);
      this.shareNaverInst.setTitle(this.letter.firstPayOff);

      // 设置分享链接
      this.shareFacebookInst.setUrl(this.shareUrl + '&cid=share&scid=facebook');
      this.shareSystemInst.setUrl(this.shareUrl + '&cid=share&scid=other');
      this.shareTwitterInst.setUrl(this.shareUrl + '&cid=share&scid=twitter');
      this.shareLineInst.setUrl(this.shareUrl + '&cid=share&scid=line');
      this.shareNaverInst.setUrl(this.shareUrl + '&cid=share&scid=naver');
      this.shareVkInst.setUrl(this.shareUrl + '&cid=share&scid=vk');
    },
    // 批量配置
    initShareSetting() {
      this.shareList = [
        this.shareFacebookInst,
        this.shareSystemInst,
        this.shareTwitterInst,
        this.shareLineInst,
        this.shareNaverInst,
        this.shareVkInst
      ];
      this.shareList.forEach(item => {
        item.setContent(this.letter.firstPayOff);
        item.setPointsInfo(this.gameId, this.gameInfoConfig.sharePointAid);
        // 分享成功的回调
        item.setShareSuccessCallback((...args) => {
          try {
            this.sharePoint('share_result', item?.pointName, true);
          } catch (e) {
            console.error(e);
          }
        });
        // 分享失败的回调
        item.setShareFailCallback((
          errorMsg, // 错误信息
          socialType, // 分享类型
          ...args // 其它参数
        ) => {
          try {
            this.sharePoint('share_result', item?.pointName, false, errorMsg);
          } catch (e) {
            console.error(e);
          }
        })
      });
    }
  },
  watch: {
    visible(val) {
      // 弹窗弹起+语言有变化，就重新初始化分享
      if (val && this.beforeLang !== this.lang) {
        this.initShare();
        this.beforeLang = this.lang;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/webStore.scss';

.share {
  z-index: 13;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &-main {
    text-align: center;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('voucher-about-popup.png');

    .share-group {
      margin-top: 150px;
      height: 100%;
      width: 100%;

      .share-btn {
        margin: 25px;
        display: inline-block;
        width: 100px;
        height: 100px;
        text-align: center;
        position: relative;

        .share-btn-text {
          font-size: 26px;
          color: #ffffff;
          margin-top: 10px;
        }

        .vkshare-btn {
          position: absolute;
          width: 100px;
          height: 100px;

          a {
            width: 100px;
            height: 100px;
          }
        }
      }

      $shareList: facebook, twitter, kakao, line, vk, naver, more;

      @each $item in $shareList {
        .#{$item} {
          width: 100px;
          height: 100px;
          line-height: 150px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          display: inline-block;
          @psetbg ('#{$item}_btn.png', false, false);
        }
      }

      a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .main {
    &-close {
      position: absolute;
      right: 25px;
      top: 28px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('close.png');
    }
  }
}
</style>
